import pariahOgg from '../../assets/audio/gameplay-music/pariah-battle.ogg?url';
import pariahMp3 from '../../assets/audio/gameplay-music/pariah-battle.mp3?url';
import metalmaniaOgg from '../../assets/audio/gameplay-music/metalmania-battle.ogg?url';
import metalmaniaMp3 from '../../assets/audio/gameplay-music/metalmania-battle.mp3?url';
import waltzOgg from '../../assets/audio/gameplay-music/burn-the-world-waltz-battle.ogg?url';
import waltzMp3 from '../../assets/audio/gameplay-music/burn-the-world-waltz-battle.mp3?url';

const pending = new Map<string, Promise<ArrayBuffer>>();
function load(url: string): Promise<ArrayBuffer> {
  const cached = pending.get(url);
  if (cached) return cached;
  const task = fetch(url).then(async (response) => {
    if (!response.ok) throw new Error(`Battle music fetch ${response.status}`);
    return response.arrayBuffer();
  });
  pending.set(url, task);
  void task.catch(() => {
    pending.delete(url);
  });
  return task;
}

/** Ordered musical arcs, not short loops: pressure, drive, then a different rhythm. */
export function battleSoundtrack(doc: Document) {
  const opus = !!doc.createElement('audio').canPlayType('audio/ogg; codecs="opus"');
  return [
    { id: 'pariah', load: () => load(opus ? pariahOgg : pariahMp3) },
    { id: 'metalmania', load: () => load(opus ? metalmaniaOgg : metalmaniaMp3) },
    { id: 'burn-the-world-waltz', load: () => load(opus ? waltzOgg : waltzMp3) },
  ];
}

/** Optional compressed preparation follows first paint; never opens audio hardware. */
export function prepareBattleSoundtrack(doc: Document): void {
  const view = doc.defaultView;
  if (!view || typeof view.requestAnimationFrame !== 'function') return;
  view.requestAnimationFrame(() => {
    view.setTimeout(() => {
      if (doc.visibilityState !== 'hidden')
        void battleSoundtrack(doc)[0]!
          .load()
          .catch(() => {});
    }, 1000);
  });
}

const cc = { license: 'CC BY 4.0', licenseHref: 'https://creativecommons.org/licenses/by/4.0/' };
export const battleMusicCredits = [
  {
    ...cc,
    title: 'Pariah — Scott Buckley',
    href: 'https://www.scottbuckley.com.au/library/pariah/',
    description: 'No Melody Mix: сокращён, вход и выход, снижение громкости для боя.',
  },
  {
    ...cc,
    title: 'Metalmania — Kevin MacLeod',
    href: 'https://incompetech.com/music/royalty-free/index.html?isrc=USUAN1700023',
    description: 'Сокращён, вход и выход, громкость выровнена для боя.',
  },
  {
    ...cc,
    title: 'Burn The World Waltz — Kevin MacLeod, Alexander Nakarada',
    href: 'https://incompetech.com/music/royalty-free/index.html?isrc=USUAN2100009',
    description: 'Сокращён, вход и выход, громкость выровнена для боя.',
  },
];
